
'use client';

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CampaignBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date('2026-03-31T23:59:59+09:00');

    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-[#2D2D2D] via-[#3A3A3A] to-[#2D2D2D] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-3 sm:py-4 relative">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-3 sm:gap-4 lg:gap-6">
          {/* Notice Badge */}
          <div className="flex items-center gap-2 sm:gap-3">
            <span className="bg-[#C45C5C] text-white text-[10px] sm:text-xs font-medium px-2 sm:px-3 py-1 rounded-full whitespace-nowrap">
              重要なお知らせ
            </span>
            <span className="text-white text-sm sm:text-base font-medium whitespace-nowrap">
              2026年4月1日より価格改定
            </span>
          </div>

          {/* Countdown Timer */}
          <div className="flex items-center gap-1 sm:gap-2 bg-white/10 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full">
            <span className="text-white/70 text-[10px] sm:text-xs mr-1 hidden sm:inline">現行価格での予約は</span>
            <div className="flex items-center gap-1">
              <div className="flex flex-col items-center">
                <span className="text-white font-bold text-sm sm:text-base leading-none">
                  {String(timeLeft.days).padStart(2, '0')}
                </span>
                <span className="text-white/50 text-[8px] sm:text-[10px]">日</span>
              </div>
              <span className="text-white/50 text-xs sm:text-sm">:</span>
              <div className="flex flex-col items-center">
                <span className="text-white font-bold text-sm sm:text-base leading-none">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <span className="text-white/50 text-[8px] sm:text-[10px]">時</span>
              </div>
              <span className="text-white/50 text-xs sm:text-sm">:</span>
              <div className="flex flex-col items-center">
                <span className="text-white font-bold text-sm sm:text-base leading-none">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <span className="text-white/50 text-[8px] sm:text-[10px]">分</span>
              </div>
              <span className="text-white/50 text-xs sm:text-sm">:</span>
              <div className="flex flex-col items-center">
                <span className="text-[#FF8A8A] font-bold text-sm sm:text-base leading-none animate-pulse">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
                <span className="text-white/50 text-[8px] sm:text-[10px]">秒</span>
              </div>
            </div>
          </div>

          {/* Campaign Details */}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-center sm:text-left">
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap justify-center">
              <span className="text-white text-xs sm:text-sm font-light">
                3/31まで<strong className="text-[#F5D6A0] font-semibold">価格維持予約</strong>受付中
              </span>
              <span className="text-white/60 text-[10px] sm:text-xs hidden md:inline">
                ＋先着50脚限定<strong className="text-[#F5D6A0]">Amazonギフト券5,000円</strong>
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <Link
            to="/campaign"
            className="bg-white hover:bg-white/90 text-[#2D2D2D] text-xs sm:text-sm font-medium px-4 sm:px-5 py-2 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 hover:scale-105"
          >
            価格維持予約はこちら
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Close Button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-1/2 right-2 sm:right-4 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer"
          aria-label="閉じる"
        >
          <i className="ri-close-line text-lg"></i>
        </button>
      </div>
    </div>
  );
}
